import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy link used in earlier emails. Keeps those links working by sending
 * people to the live membership page instead of a "page not found".
 */
export const Route = createFileRoute("/membership-journey")({
  beforeLoad: () => {
    throw redirect({ to: "/membership" });
  },
  component: () => null,
});
